import { render, staticRenderFns } from "./userLaw.vue?vue&type=template&id=36921530&scoped=true&"
import script from "./userLaw.vue?vue&type=script&lang=js&"
export * from "./userLaw.vue?vue&type=script&lang=js&"
import style0 from "./userLaw.vue?vue&type=style&index=0&id=36921530&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36921530",
  null
  
)

export default component.exports